import { render, staticRenderFns } from "./BalanceMovesTable.vue?vue&type=template&id=6531a994&"
import script from "./BalanceMovesTable.vue?vue&type=script&lang=ts&"
export * from "./BalanceMovesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports